import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { injectIntl } from 'react-intl'

import { Game, Firebase, Auth } from '../../../Core'

import ProfileScreen from './Profile'

import * as selectors from '../profile.selectors'

const mapStateToProps = (state) => ({
  battles: selectors.getProfileBattlesData(state),
  userData: Firebase.selectors.getUserData(state),
  groupData: Firebase.selectors.getGroupData(state),
  players: Firebase.selectors.getPlayersRanking(state),
  rankingObfuscated: Firebase.selectors.getObfuscatedRankingFlag(state),
  user: Auth.selectors.getUserInfo(state),
})

const mapDispatchToProps = (dispatch) => ({
  removeScreen: bindActionCreators(Game.actions.removeScreen, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ProfileScreen))
